export default __webpack_public_path__ + "static/media/icono-1.c6d30e22.jpg";